import { useCallback, useState } from "react";
import { EventPlatformEntry } from "@kaltura/mediaspace-shared-types";
import { Carousel, slickClasses } from "@kaltura/mediaspace-shared-ui";
import NewsItem from "./NewsItem";
import NewsItemModal from "./NewsItemModal";
import styled from "@emotion/styled";

interface Props {
    entries: EventPlatformEntry[];
    modalBoxMaskColor?: string;
}

const StyledContainer = styled("div")(({ theme }) => ({
    width: "100%",
    paddingTop: 60,
    paddingBottom: 60,
    backgroundColor: theme.kaltura.palette.tone7,
    [`& .${slickClasses.slide} div`]: {
        width: "100%",
    },
    [theme.breakpoints.down(theme.breakpoints.values.lg - 0.05)]: {
        paddingTop: 40,
        paddingBottom: 40,
    },
}));

/**
 * News Component displays news playlist in a carousel
 */
export const News = (props: Props) => {
    const { entries, modalBoxMaskColor } = props;
    const [selectedEntry, setSelectedEntry] = useState<EventPlatformEntry | null>(null);

    const handleItemClick = useCallback(
        (entry: EventPlatformEntry) => {
            setSelectedEntry(entry);
        },
        []
    );

    const handleModalClose = useCallback(() => {
        setSelectedEntry(null);
    }, []);

    return (
        <StyledContainer id="kms-ds-homepage-component-news">
            <Carousel
                items={entries}
                currentCardsNumberInSlides={3}
                itemComponent={NewsItem}
                itemProps={{
                    modalBoxMaskColor,
                    onClick: handleItemClick,
                }}
                container={"News Item"}
            />
            {selectedEntry && (
                <NewsItemModal
                    show={true}
                    onHide={handleModalClose}
                    name={selectedEntry.name}
                    description={selectedEntry.description ?? ""}
                    startDate={selectedEntry.updatedAt!}
                    thumbnailUrl={selectedEntry.thumbnailUrl}
                    modalBoxMaskColor={modalBoxMaskColor}
                />
            )}
        </StyledContainer>
    );
};

export default News;
